import React from 'react';
import './about.css';
const About = () => {
  return (
    <div className="about section__padding gradient__bg" id="about">
      <h3 className="gradient__text">About</h3>
      <div className="about-container">
        <p>Alex Kreizelman is a React enthusiast who lives in Israel.</p>
        <p>
          Developing web applications and websites using popular technologies
          such as React, Next.js, Node.js and many more.
        </p>
        <p>
          If you want to work together visit me on{' '}
          <a href="https://www.linkedin.com/in/alex-kreizelman-846178219/">
            LinkedIn
          </a>{' '}
          or leave me a DM <a href="#home">here</a>.
        </p>
      </div>
    </div>
  );
};

export default About;
